import React, { useLayoutEffect, useRef } from "react";
import ReactApexChart from "react-apexcharts";

// ApexCharts.destroy() throws when a chart never finished rendering, and a throw
// inside componentWillUnmount while the parent is unmounting escapes React 16's
// commit and leaves the page rendered but unresponsive. Destroy it here first,
// swallowing the error, so react-apexcharts finds nothing left to destroy.
const SafeApexChart = props => {
  const ref = useRef(null);
  useLayoutEffect(
    () => () => {
      const inst = ref.current;
      if (!inst || !inst.chart) return;
      try {
        inst.chart.destroy();
      } catch (e) {
        // chart never mounted its DOM; nothing to clean up
      }
      inst.chart = null;
    },
    []
  );
  return <ReactApexChart ref={ref} {...props} />;
};

export default SafeApexChart;
